<script setup lang="ts">
import IconBag from 'assets/icons/bag.svg';

const cart = useCartStore();
const route = useRoute();

const emit = defineEmits(['click']);

const openCart = async () => {
  await navigateTo('/cart');
  emit('click');
};

const hasItems = computed(() => {
  return Object.values(cart.list).length > 0;
});

const isOpen = computed(() => {
  return route.name === 'cart';
});
</script>

<template>
  <div class="relative w-fit h-fit">
    <ButtonActive
      :active="isOpen"
      type="2"
      @click="openCart"
    >
      <template #append>
        <IconBag />
      </template>
    </ButtonActive>
    <div
      v-show="hasItems"
      class="w-2.5 h-2.5 bg-red-500 absolute top-2 right-2 rounded-full"
    />

    <CartAddNofitication />
  </div>
</template>
